var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfaOktaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#e51636}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0V0z",
    fill: "none",
    id: "Layer_3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logosandtypes_com"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5 36.4c3.7 3.3 8.9 4.3 11 1.9 2.1-2.5.2-7.6-3.5-10.8-3.7-3.3-7.7-3.3-9.8-.8-2.1 2.4-1.4 6.4 2.3 9.7zM72.5 32.4c4-1.9 4.5-9.6 1.5-16.3-3-6.6-8-9.1-12-7.2-4 1.9-5.4 7.5-2.5 14.1 2.9 6.6 8.9 11.3 13 9.4zM85.9 31.8C91.2 33 97.3 25.7 99.1 17 101 8.3 97.8 1.9 92.4.7 87.1-.5 81.6 4 79.8 12.7c-1.8 8.7.8 17.9 6.1 19.1zM102.4 76.1c11.1-7.9 16.5-5.7 16.5-8.6 0-3.2-8.5-9.2-14.5-9.8.1 1.7.1 3.5 0 5.3-.4 4.4-1 8.8-2 13.1zM99.3 39c4.1 5.6 15.7 3.8 24.6-3 8.9-6.8 11.1-15.6 7-21.2s-12.9-6-21.8.8c-8.8 6.9-13.9 17.8-9.8 23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.6 133.7C49 132.4 40 118.7 41.1 100c1.5-26.3 21.7-58 41-56 6.8.7 11.4 6.8 10.7 20.1-.8 15.4-11.7 37.8-23.1 37.1-5.3-.3-6.9-5.8-6.5-10.7.9-10.6 6.1-13.5 6.5-17.8.2-2.5-2.3-3.6-4.2-3-3.2 1-9.5 9.1-10.3 20.6-.9 14 8.1 18.4 13.4 18.7 15.8.9 31.3-21.7 32.6-45.6.9-15.4-5.7-25.4-18.1-26.8C59 34 33.7 66.4 32.4 100.3c-.8 20.3 9.7 39.5 32 41.2 8.3.5 32.1-2.5 51.2-31.3 1.3-2 .7-4.7-1.3-5.9-2-1.2-4.6-.6-5.8 1.4-14.7 24.1-35.6 28.7-43.9 28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1 58.4c0-1.1 0-3.5-2.7-3.5-3.3.1-6.8 6.1-5.4 9.4 2.6 4.2 8-1.4 8.1-5.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfaOktaLogo);
export default __webpack_public_path__ + "static/media/cfa-okta-logo.3d1b3993a727751bd0ef6ed85578a812.svg";
export { ForwardRef as ReactComponent };